import { PlanV3, RightTab } from "./types";

export function planHasElements(plan: PlanV3 | null): boolean {
  return (plan?.groupedElements?.all?.count ?? 0) > 0;
}

export function planHasCables(plan: PlanV3 | null): boolean {
  return (plan?.routeGroups?.length ?? 0) > 0;
}

export function pickBestTab(
  plan: PlanV3 | null,
  hasBoard: boolean,
  preferred?: RightTab,
): RightTab {
  const hasEl = planHasElements(plan);
  const hasCab = planHasCables(plan);

  // Project-level tab (not per-plan) — keep it across plan switches.
  if (preferred === "cabletakeoff") return "cabletakeoff";

  if (preferred === "plan" && hasEl) return "plan";
  if (preferred === "cables" && hasCab) return "cables";
  if (preferred === "board" && hasBoard) return "board";

  if (hasEl) return "plan";
  if (hasCab) return "cables";
  if (hasBoard) return "board";
  return "plan";
}
